import React from 'react';

import cn from './style.module.sass';

const PageTitle: React.FC = ({ children }) => <h1 className={cn.title}>{children}</h1>;
export default PageTitle;
